import { Route, Navigate } from "react-router-dom";
import { isAdminRole } from './helpers';
import lazyWithRetry from '../../utils/lazyWithRetry';

// Lazy-loaded pages
const LeadManagement = lazyWithRetry(() => import('../../features/lead-management/LeadManagement'));
const LeadDetailPage = lazyWithRetry(() => import('../../pages/LeadDetailPage'));
const ProviderDirectoryPage = lazyWithRetry(() => import('../../pages/ProviderDirectoryPage'));
const AccessDenied = lazyWithRetry(() => import('../../components/AccessDenied'));

/** Lead Routes - Routes for lead/CRM management */
export function LeadRoutes({ user, userHasRole }) {
  return (
    <>
      {/* Lead Management */}
      <Route
        path="/leads"
        element={
          user === null
            ? <div>Checking login...</div>
            : user && (isAdminRole(user) || userHasRole(user, 'intake_coordinator'))
            ? <LeadManagement />
            : user
            ? <AccessDenied 
                title="Lead Management Access Restricted"
                message="You need admin, clinical director, or intake coordinator permissions to access Lead Management."
                requiredRole="Admin, Clinical Director, or Intake Coordinator"
                backTo="/dashboard"
              />
            : <Navigate to="/login" />
        }
      />

      {/* Lead Management - Admin route alias */}
      <Route
        path="/admin/leads"
        element={
          user === null
            ? <div>Checking login...</div>
            : user && (isAdminRole(user) || userHasRole(user, 'intake_coordinator'))
            ? <LeadManagement />
            : user
            ? <AccessDenied 
                title="Lead Management Access Restricted"
                message="You need admin, clinical director, or intake coordinator permissions to access Lead Management."
                requiredRole="Admin, Clinical Director, or Intake Coordinator"
                backTo="/admin/dashboard"
              />
            : <Navigate to="/login" />
        }
      />

      {/* Lead Detail Page */}
      <Route
        path="/admin/leads/:leadId"
        element={
          user === null
            ? <div>Checking login...</div>
            : user && (isAdminRole(user) || userHasRole(user, 'intake_coordinator'))
            ? <LeadDetailPage />
            : user
            ? <AccessDenied 
                title="Lead Detail Access Restricted"
                message="You need admin, clinical director, or intake coordinator permissions to view lead details."
                requiredRole="Admin, Clinical Director, or Intake Coordinator"
                backTo="/admin/dashboard"
              />
            : <Navigate to="/login" />
        }
      />

      {/* Provider Directory */}
      <Route
        path="/admin/provider-directory"
        element={
          user === null
            ? <div>Checking login...</div>
            : user && (isAdminRole(user) || userHasRole(user, 'intake_coordinator'))
            ? <ProviderDirectoryPage />
            : user
            ? <AccessDenied 
                title="Provider Directory Access Restricted"
                message="You need admin, clinical director, or intake coordinator permissions to access the Provider Directory."
                requiredRole="Admin, Clinical Director, or Intake Coordinator"
                backTo="/admin/dashboard"
              />
            : <Navigate to="/login" />
        }
      />

      {/* Lead Detail Page - Non-admin route */}
      <Route
        path="/leads/:leadId"
        element={
          user === null
            ? <div>Checking login...</div>
            : user && (isAdminRole(user) || userHasRole(user, 'intake_coordinator'))
            ? <LeadDetailPage />
            : user
            ? <AccessDenied 
                title="Lead Detail Access Restricted"
                message="You need admin, clinical director, or intake coordinator permissions to view lead details."
                requiredRole="Admin, Clinical Director, or Intake Coordinator"
                backTo="/dashboard"
              />
            : <Navigate to="/login" />
        }
      />
    </>
  );
}
